export default __webpack_public_path__ + "static/handfile-d4208525d81b8ffda98403fffa7f1e5b.png";